module.exports = __webpack_public_path__ + "static/img/rightsnap.054a9910.svg";